import { useSnapshot } from 'valtio'
import { CircleF } from '@react-google-maps/api'
import * as React from 'react'
import { historyState } from '../../../../store/historyState.ts'
import { controlState } from '../../../../store/controlState.ts'
import { estimateDeviationFromReport, getMeanAndStd } from './highlightHelpers.ts'

const accuracyStyle = {
    strokeColor: 'blue',
    strokeOpacity: 0,
    strokeWeight: 1,
    fillColor: 'blue',
    fillOpacity: 0.1,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    zIndex: 1
}

export const HighlightMarker: React.FC = () => {
    const point = (useSnapshot(historyState) as typeof historyState).highlight
    const isMobile = useSnapshot(controlState).isOnMobileDevice

    if (!point) return null

    // Mobile: highlight is built into the marker icon itself, no separate circle needed
    if (isMobile) return null

    const latLng = new google.maps.LatLng({
        lat: point.properties?.latitude,
        lng: point.properties?.longitude,
    })

    // Desktop: accuracy-based circles
    let stats = getMeanAndStd(point.properties.accuracy?.toFixed(1))
    if (!stats) {
        stats = {
            mean: estimateDeviationFromReport(point),
            std: estimateDeviationFromReport(point)
        }
    }

    return (
        <div>
            <CircleF
                center={latLng}
                radius={stats.std}
                options={accuracyStyle}
            />
            <CircleF
                center={latLng}
                radius={stats.mean}
                options={accuracyStyle}
            />
            <CircleF
                center={latLng}
                radius={0.5}
                options={{...accuracyStyle, fillOpacity: 1}}
            />
        </div>
    )
}
